import { Dictionary } from "../../../utils/sys/Dictionary";
import KeyedValueSorter from "./KeyedValueSorter";
import School from "../../../utils/game/mechanics/School";

export type SortKey = "title" | "description";

export default class SchoolSorter extends KeyedValueSorter {
    protected static override valueGetters = new Dictionary<SortKey, (school: School) => string | number>([
        { key: "title", value: (ability) => ability.title },
        { key: "description", value: (ability) => ability.description }
    ]);
}
